/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function PickaxeIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="pickaxe"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M13.939 6.525C14.72 5.744 15.987 5.744 16.768 6.525L17.475 7.232C18.256 8.013 18.256 9.28 17.475 10.061L16.061 11.475C15.28 12.256 14.013 12.256 13.232 11.475L12.525 10.768C11.744 9.987 11.744 8.72 12.525 7.939L13.939 6.525Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14.646 5.818C13.107 4.278 10.883 3.641 8.761 4.13L7.575 4.404L11.818 8.646" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.182 9.354C19.722 10.893 20.359 13.117 19.87 15.239L19.596 16.425L15.354 12.182" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M13.586 11.828L7.795 18.777C7.108 19.602 5.86 19.659 5.101 18.899C4.341 18.14 4.398 16.892 5.223 16.205L12.172 10.414" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
